import { createContext } from 'react';
import {
  ICredential,
  IUserData,
  IUserMetaData,
  IUserPublicMetaData,
} from '../model';
import React from 'react';

export interface ITenant {
  is_admin: boolean;
  key: string;
  name: string;
  public: any;
}

export interface IAppData {
  ibl_edx_url: string;
  tenants: string;
  tenant: string;
  axd_token: string;
  ibl_axd_url: string;
  axd_token_expires: Date;
  ibl_search_url: string;
  ibl_web_url: string;
  userData: IUserData;
  userMetaData: IUserMetaData;
  userMetaDataLoaded: boolean;
  userCredentials: ICredential[];
  userCredentialsLoaded: boolean;
  token: string;
  current_tenant: ITenant;
  ibl_user_public_metadata?: IUserPublicMetaData;
  userInContext: string;
  userIdInContext: number;
  sidebarCopilotTriggered?: boolean;
}

type IAppDataSetFunc = (appData: IAppData) => void;

export const AppDataContext = createContext<{
  appData: IAppData;
  setAppData: IAppDataSetFunc;
} | null>(null);

export const VisibilityContext = React.createContext<
  | {
      visibilityData: { showHeader: boolean; showProfileNav: boolean };
      setVisibilityData: React.Dispatch<
        React.SetStateAction<{ showHeader: boolean; showProfileNav: boolean }>
      >;
    }
  | undefined
>(undefined);
